export default __webpack_public_path__ + "files/BC8.pdf";